import { render, staticRenderFns } from "./DashboardForm.vue?vue&type=template&id=125e3079"
import script from "./DashboardForm.vue?vue&type=script&lang=js"
export * from "./DashboardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports